import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { ScrollReveal } from '@/components/feature/PageLayout';
import { articles } from '@/pages/blog/data';

export default function BlogPage() {
  return (
    <>
      <Navbar />
      <main className="bg-background-100">
        {/* Header */}
        <section className="w-full pt-28 md:pt-36 pb-8 md:pb-12">
          <div className="max-w-[1280px] mx-auto px-6 md:px-10 lg:px-16">
            <div className="reveal-on-scroll">
              <div className="flex items-center gap-4 mb-6">
                <span className="h-px w-12 md:w-16 bg-accent-500" />
                <span className="text-[11px] md:text-xs tracking-[0.28em] uppercase text-accent-600">
                  Reflexiones
                </span>
              </div>
            </div>
            <h1 className="font-heading text-6xl md:text-7xl lg:text-8xl font-light text-black leading-[1.05]">
               Blog
            </h1>
            <p className="text-foreground-600 text-base md:text-lg leading-relaxed max-w-[520px] mt-6 reveal-on-scroll">
              Reflexiones sobre liderazgo, claridad y mentoría estratégica.
            </p>
          </div>
        </section>

        {/* Posts */}
        <section className="w-full pb-20 md:pb-28">
          <div className="max-w-[1280px] mx-auto px-6 md:px-10 lg:px-16">
            <ScrollReveal>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-7">
                {articles.map((article, i) => (
                  <Link
                    key={article.slug}
                    to={`/blog/${article.slug}`}
                    className="reveal-on-scroll group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 shadow-[0_12px_40px_rgba(15,23,42,0.06)] transition-all duration-300 hover:-translate-y-1.5 cursor-pointer"
                    style={{ transitionDelay: `${i * 100}ms` }}
                  >
                    <div className="relative w-full aspect-[16/10] overflow-hidden">
                      <img
                        src={article.image}
                        alt={article.imageAlt}
                        className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-[1.04]"
                      />
                    </div>

                    <div className="p-5 md:p-6 flex flex-col">
                      <div className="flex items-center gap-3 mb-4">
                        <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-[11px] font-medium tracking-[0.12em] uppercase">
                          {article.category}
                        </span>
                        <span className="text-xs text-foreground-400">{article.dateLabel}</span>
                      </div>

                      <h2 className="font-heading text-lg md:text-xl font-semibold leading-[1.25] text-foreground-900 mb-3 group-hover:text-accent-700 transition-colors duration-300">
                        {article.title}
                      </h2>

                      <p className="text-sm text-foreground-600 leading-relaxed mb-5">
                        {article.excerpt}
                      </p>

                      <div className="mt-auto flex items-center justify-between pt-4 border-t border-background-200">
                        <span className="inline-flex items-center gap-1.5 text-xs text-foreground-400">
                          <span className="w-4 h-4 flex items-center justify-center">
                            <i className="ri-time-line"></i>
                          </span>
                          {article.readTime} de lectura
                        </span>
                        <span className="inline-flex items-center gap-2 text-sm font-medium text-foreground-900 group-hover:gap-3 transition-all duration-300 whitespace-nowrap">
                          Leer más
                          <span className="w-4 h-4 flex items-center justify-center">
                            <i className="ri-arrow-right-line"></i>
                          </span>
                        </span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </ScrollReveal>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}